import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';
import spinalImg from '../assets/img/icons/spinal-cord.png';
import brainImg from '../assets/img/icons/brain.png';
import brainImg2 from '../assets/img/icons/brain2.png';
import brainImg3 from '../assets/img/icons/brain3.png';
import lungImg from '../assets/img/icons/lungs.png';
import childrenImg from '../assets/img/icons/children.png';
import nurseImg from '../assets/img/icons/nurse.png';
import storyImg from '../assets/img/icons/story.png';

function CareView() {
  useDocumentTitle('Our Care-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-16'} title={'Our Care'} link={'our-care'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                We deliver personal and complex care in your home
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  Our personal and complex care packages are created with you,
                  and family members or advocates where necessary, and are
                  designed to meet your individual clinical, personal, and
                  social care needs.
                </p>
                <p className="values_p3">
                  For families with children or young people, our care packages
                  allow you to spend more quality family time together.
                </p>
                <p className="values_p3">
                  We can also support you during your rehabilitation period by
                  providing you with a care package that supports your needs,
                  allowing you to live as independently as possible.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <h2 className="white-color">The care we deliver</h2>
              </div>
            </div>
            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={brainImg}
                      className=" ltn__feature-icon-2"
                    />
                  </span>
                  <h3 className="white-color">Brain injury</h3>
                  <p className="white-color">
                    Support through your rehabilitation and with your ongoing
                    needs.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link to="/brain-injury" className="theme-btn-1 btn-effect-1">
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={spinalImg}
                      className=" ltn__feature-icon-2"
                    />{' '}
                  </span>
                  <h3 className="white-color">Spinal injury</h3>
                  <p className="white-color">
                    Specialist personalised care to meet your ongoing needs.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link
                    to="/spinal-injury"
                    className="theme-btn-1 btn-effect-1"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={lungImg}
                      className=" ltn__feature-icon-2"
                    />{' '}
                  </span>
                  <h3 className="white-color">Airway management</h3>
                  <p className="white-color">
                    The highest standards of complex clinical care in your home.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link
                    to="/ventilation-and-airway"
                    className="theme-btn-1 btn-effect-1"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={childrenImg}
                      className=" ltn__feature-icon-2"
                    />{' '}
                  </span>
                  <h3 className="white-color">Young people</h3>
                  <p className="white-color">
                    A holistic approach to support the whole family to live well
                    at home.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link to="/children" className="theme-btn-1 btn-effect-1">
                    Learn more
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={brainImg2}
                      className=" ltn__feature-icon-2"
                    />
                  </span>
                  <h3 className="white-color">Learning disability</h3>
                  <p className="white-color">
                    Personalised support to meet your individual needs.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link
                    to="/learning-disability"
                    className="theme-btn-1 btn-effect-1"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={brainImg3}
                      className=" ltn__feature-icon-2"
                    />{' '}
                  </span>
                  <h3 className="white-color">Neurological issues</h3>
                  <p className="white-color">
                    Specialist personalised care to meet your ongoing needs.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link
                    to="/neurological-conditions"
                    className="theme-btn-1 btn-effect-1"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={nurseImg}
                      className=" ltn__feature-icon-2"
                    />{' '}
                  </span>
                  <h3 className="white-color">Nursing packages</h3>
                  <p className="white-color">
                    Personal care services in your own home.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link to="/nursing-care" className="theme-btn-1 btn-effect-1">
                    Learn more
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-3 pt-3">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <div className="ltn__feature-info">
                  <span>
                    <img
                      alt="icon"
                      src={storyImg}
                      className=" ltn__feature-icon-2"
                    />{' '}
                  </span>
                  <h3 className="white-color">Real stories</h3>
                  <p className="white-color">
                    Supporting people and their families every step of the way.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link to="/testimonials" className="theme-btn-1 btn-effect-1">
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default CareView;
